/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Resource_ConsentInputs */

const en_doc_type_resource_consent = /** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource Consent`)
};

const id_doc_type_resource_consent = /** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin Sumber Daya`)
};

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const es_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const fr_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const de_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const ja_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const zh_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const ar_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const it_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const ru_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const pt_doc_type_resource_consent = en_doc_type_resource_consent;

/** @type {(inputs: Doc_Type_Resource_ConsentInputs) => LocalizedString} */
const ko_doc_type_resource_consent = en_doc_type_resource_consent;

/**
* | output |
* | --- |
* | "Resource Consent" |
*
* @param {Doc_Type_Resource_ConsentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_resource_consent = /** @type {((inputs?: Doc_Type_Resource_ConsentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Resource_ConsentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_resource_consent(inputs)
	if (locale === "es") return es_doc_type_resource_consent(inputs)
	if (locale === "fr") return fr_doc_type_resource_consent(inputs)
	if (locale === "de") return de_doc_type_resource_consent(inputs)
	if (locale === "ja") return ja_doc_type_resource_consent(inputs)
	if (locale === "zh") return zh_doc_type_resource_consent(inputs)
	if (locale === "ar") return ar_doc_type_resource_consent(inputs)
	if (locale === "id") return id_doc_type_resource_consent(inputs)
	if (locale === "it") return it_doc_type_resource_consent(inputs)
	if (locale === "ru") return ru_doc_type_resource_consent(inputs)
	if (locale === "pt") return pt_doc_type_resource_consent(inputs)
	return ko_doc_type_resource_consent(inputs)
});